import React from 'react';
import { MdInventory } from 'react-icons/md';
import { TbInfinity } from "react-icons/tb";

const StockTag = ({ tipo, stock, position = 'center' }) => {
    const isServicio = tipo === 'servicio';

    const TagPosition = position === 'right' ? 'justify-end' : position === 'left' ? 'justify-start' : 'justify-center'

    const stockColor = stock === 0
        ? 'bg-gradient-to-r from-red-500 to-red-600 dark:from-red-600 dark:to-red-700'
        : stock <= 3
            ? 'bg-gradient-to-r from-amber-400 to-amber-500 dark:from-amber-500 dark:to-amber-600'
            : 'bg-gradient-to-r from-green-400 to-green-500 dark:from-green-500 dark:to-green-600';

    return (
        <div className={`flex ${TagPosition} items-center`}>
            {isServicio ? (
                <span className="text-sm font-bold bg-gradient-to-r from-green-400 to-green-500 dark:from-green-500 dark:to-green-600 text-white py-1 px-3 rounded-xl flex items-center gap-1">
                    <TbInfinity size={24}/> Ilimitado
                </span>
            ) : (
                <span className={`text-sm font-bold ${stockColor} text-white py-1 px-3 rounded-xl flex items-center gap-2`}>
                    <MdInventory size={24}/> {stock}
                </span>
            )}
        </div>
    );
};

export default StockTag;
